export const CbTopBaseResources = {
    registerText: "Dołącz do goodie",
    title: "Cashback - <b>zwroty pieniędzy za zakupy</b>",
    subTitle: "Rób zakupy w ulubionych sklepach internetowych i otrzymuj zwroty części wydanych pieniędzy.",
};
